import React from 'react';

const HomeStudentContentGreen = () => {
    return (
        <div className='w-[70%] mx-auto my-10'>
            <div className="flex justify-between gap-5 h-[600px]">
            <div className="relative h-[600px] w-[35%]">
        <img
          className="rounded-lg w-full h-full object-cover"
          src="https://i.ibb.co.com/bzKgbg8/d6b839bf-638d-4c98-acb4-debeb43bb529.jpg"
          alt=""
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black to-green-600 opacity-60 rounded-lg"></div>

        {/* Text on top of the overlay */}
        <div className="absolute inset-0 flex flex-col justify-between items-start p-10">
         
        </div>
      </div>
        <div className="w-[65%] flex flex-col justify-between bg-green-100 rounded-lg p-10">
          <h1 className="text-6xl font-signika text-black ">
            How does it work for <br></br> guardians/students?
          </h1>
          <div>
            <div className="mt-10 flex flex-row items-center gap-5">
              <div></div>
              <div>
                <h1 className="text-3xl font-signika text-green-900">
                  Submit Your Tutor Request
                </h1>
                <p className="text-lg font-signika text-green-900">
                  Fill out all the required fields and submit your request.
                </p>
              </div>
            </div>
            <div className="mt-10 flex flex-row items-center gap-5">
              <div></div>
              <div>
                <h1 className="text-3xl font-signika text-green-900">
                Get the Maximum 5 Best Tutor CVs
                </h1>
                <p className="text-lg font-signika text-green-900">
                Within 48 hours, you'll get up to 5 CVs of the best tutors who applied to your posted job.
                </p>
              </div>
            </div>
            <div className="mt-10 flex flex-row items-center gap-5">
              <div></div>
              <div>
                <h1 className="text-3xl font-signika text-green-900">
                Select the Best One & Start Learning
                </h1>
                <p className="text-lg font-signika text-green-900">
                Select a tutor from the shortlist and take trial classes to confirm your tutor.
                </p>
              </div>
            </div>
          </div>
        </div>
       
        {/* <div className="w-[53%] rounded-lg">
          <img src="https://i.ibb.co.com/RY6rttt/a7a2a753-df2d-44c2-ac3e-9722df717ea1.jpg" alt=""></img>
        </div> */}
      </div>
        </div>
    );
};

export default HomeStudentContentGreen;